import React, { useEffect, useRef, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ChevronDown } from "react-feather";
import Loader from "../component/Loader";
import ProfileService from "../services/Profile";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import { useSelector } from "react-redux";
import Accordion from 'react-bootstrap/Accordion';
import { formatDate } from "../constants/commonFunction";

const PointsSpent = () => {
  const tokens = useSelector((state) => state.userTypeSlice.token);
  const [isSelectedItem, setIsSelectedItem] = useState("");
  const [isPointStatementData, setIsPointStatementData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAllTab, setIsAllTab] = useState(true);
  const [isDebitTab, setIsDebitTab] = useState(false);
  const [isTdsDeductTab, setIsTdsDeductTab] = useState(false);
  const [isBlockedTdsTab, setIsBlockedTdsTab] = useState(false);
  const [isDebitData, setIsDebitData] = useState([]);
  const [isTdsData, setIsTdsData] = useState([]);
  const [visibleItemCount, setVisibleItemCount] = useState(15);
  const [visibleItemCountDebit, setVisibleItemCountDebit] = useState(15);
  const [visibleItemCountAll, setVisibleItemCountAll] = useState(15);
  const [currentTab, setCurrentTab] = useState("all");
  const [loadingst, setLoadingst] = useState(false);
  const [trnasc_list, settrnasc_list] = useState([]);
  const [credit_list, setcredit_list] = useState([]);
  const [debit_list, setdebit_list] = useState([]);
  const [blockedTds, setBlockedTds] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setlimit] = useState(50);
  const [hasMore, setHasMore] = useState(true);
  //   const [hasMoreDebit, setHasMoreDebit] = useState(true);
  const [loadingdata, setLoadingdata] = useState(false);
  const [tds_list, settds_list] = useState([]);

  function getBlockedTds(token) {
    ProfileService.getBockedTds(token)
      .then((res) => {
        setLoadingdata(true);
        if (res.success) {
          setBlockedTds(res.response.bolckedTds);
        }
      })
      .catch((err) => {
      })
      .finally(() => {
        setLoadingdata(false);
      });
  }

  async function getPoints(tok, from_date, to_date) {
    const trans_type = currentTab == 'all' ? 'onlyD' : currentTab == 'debit' ? 'onlyD' : 'onlyD';
    let trans_desc =   currentTab == 'tds_deduct'
    ? 'Miscredit'
    : currentTab == 'debit'
    ? 'Debit'
    : '';

    if (isTdsDeductTab) {
      trans_desc = "Miscredit";
    } else if (isDebitTab) {
      trans_desc = "Debit";
    } else {
      trans_desc = "";
    }
    // setLoadingst(true);
    // setLoadingdata(true);
    // setLoading(true)
    ProfileService.getAvailablePointsRedeemable(
      from_date,
      to_date,
      trans_type,
      trans_desc,
      limit,
      pageNo
    )
      .then((res) => {
        if (res.success === true) {
          setLoading(false);

          var trnasc_list = res.response.pointDetails.trnasc_list;
          const recreditItems = trnasc_list.filter(
            (item) =>
              item.transaction_desc === "Recredit" ||
              item.transaction_desc === "Accrual" ||
              item.transaction_desc === "Bonus"
          );
          const tdsList = trnasc_list.filter(
            (item) =>
              item.transaction_desc === "Miscredit" &&
              item.tds_points !== null
          );
          const debitList = trnasc_list.filter(
            (item) =>
              item.transaction_desc === "Redemption" ||
              item.transaction_desc === "Miscredit"
          );

          if (trnasc_list.length == 0) {
            setHasMore(false);
          } else {
            // let miscreditList = trnasc_list.filter(
            //   item => item.transaction_desc === 'Miscredit',
            // );

            
            if (pageNo == 1) {
              settds_list(tdsList);
              settrnasc_list(trnasc_list)
              setcredit_list(recreditItems)
              setdebit_list(debitList)
            } else {
              if(currentTab=="tds_deduct" && debitList.length == 0) {
                setPageNo(p => p+1);
                 return
              }   
              settds_list((p) => [...p, ...tdsList]);
              if(currentTab == "all" && trnasc_list.length==0) {
                setPageNo(p => p+1)
                return;
              }
              settrnasc_list((p) => [...p, ...trnasc_list]);
              
              setcredit_list((p) => [...p, ...recreditItems]);

              if(currentTab=="debit" && debitList.length == 0) {
                setPageNo(p => p+1);
                 return
              }
              setdebit_list((p) => [...p, ...debitList]);
            }
          }
        } else {
          setLoading(false);
          settrnasc_list([]);
          setcredit_list([]);
          setdebit_list([]);
          settds_list([]);
        }

      })
      .catch((err) => {
        setLoading(false);
      })
      .finally(() => {
        setLoadingdata(false);
        setLoading(false);
      });
  }

  useEffect(() => {
    const MyPointsDataFetch = async () => {
      try {
        getPoints(tokens.access, "", "");
      } catch (error) {
        console.error("MyPointsResponse");
      }
    };
    MyPointsDataFetch();

    return () => {
      settrnasc_list([]);
      setcredit_list([]);
      setdebit_list([]);
      settds_list([]);
      setBlockedTds([]);
    };
  }, [tokens]);

  const isFirstTabRun = useRef(true);
  const isFirstPageRun = useRef(true);

  useEffect(() => {
    if (isFirstTabRun.current) {
      isFirstTabRun.current = false;
      return;
    }
    // setTimeout(() => {
    //   setPageNo(1);
    //   setHasMore(true);
    // }, 800)
    //   if(pageNo==1){

    setPageNo(1);
    getPoints(tokens.access, "", "");
    if (isBlockedTdsTab) {
      getBlockedTds(tokens.access);
    }
    setHasMore(true);
    //   }
  }, [currentTab, isBlockedTdsTab]);
  useEffect(() => {
    if (isFirstPageRun.current) {
      isFirstPageRun.current = false;
      return;
    }
    getPoints(tokens.access, "", "");

    //   }
  }, [pageNo]);
  const handleAccordionOpen = (id) => {
    if (id == isSelectedItem) {
      setIsSelectedItem("");
    } else {
      setIsSelectedItem(id);
    }
  };
  const handleTabClick = (tabName) => {
    reset();
    setCurrentTab(tabName);
    setIsAllTab(tabName === "all");
    setIsDebitTab(tabName === "debit");
    setIsTdsDeductTab(tabName === "tds_deduct");
    setIsBlockedTdsTab(tabName === "tds_blocked");
  };
  const handleShowMore = () => {
    setPageNo((p) => p + 1);
  };
  const handleDebitShowMore = () => {
    // setVisibleItemCountDebit((prevCount) => prevCount + 10);
  };
  const handleShowMoreAll = () => {
    // setVisibleItemCountAll((prevCount) => prevCount + 10);
  };

  function reset() {
    settrnasc_list([]);
    setcredit_list([]);
    setdebit_list([]);
    settds_list([]);
    setBlockedTds([]);
    setPageNo(1);
    setHasMore(true);
  }
  return (
    <>
      {loading && <Loader />}
      <BreadCrumbSecttion
        pageTitle="Points Spent"
        currentPageName="Points Spent"
      />
      <section className="padTop50">
        <div className="dashboard-details">
          <Container>
            <Row>
              <Col>
                <div className="notificationTabList">
                  <ul>
                    <li
                      onClick={() => handleTabClick("all")}
                      className={isAllTab ? "active" : ""}
                    >
                      <Link>All</Link>
                    </li>
                    <li
                      onClick={() => handleTabClick("debit")}
                      className={isDebitTab ? "active" : ""}
                    >
                      <Link>Debit</Link>
                    </li>
                    <li
                      onClick={() => handleTabClick("tds_deduct")}
                      className={isTdsDeductTab ? "active" : ""}
                    >
                      <Link>TDS Deduct</Link>
                    </li>
                    <li
                      onClick={() => handleTabClick("tds_blocked")}
                      className={isBlockedTdsTab ? "active" : ""}
                    >
                      <Link>TDS Blocked</Link>
                    </li>
                  </ul>
                </div>
                <div className="userInfoBox py-0">
                  <div className="dashboard-details">
                    {/* {isAllTab && (
                      <Row>
                        {trnasc_list?.map((item, index) => {
                          const type =
                            item.transaction_type == "D" ? "minus" : "plus";
                          const title = item.transaction_desc;
                          const points =
                            currentTab == "tds_deduct"
                              ? item.tds_points
                              : item.reward_points;
                          const dateTime = new Date(item.created_at);
                          const formattedDateTime = dateTime.toLocaleString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                              hour12: true,
                            }
                          );
                          return (
                            <Col xs={12} key={index}>
                              <div className="pointsSpentBlock ad-acc">
                                <div className="pointsSpentAmount col text-right">
                                  <p>{`${title} ${
                                    !!item?.comment
                                      ? "(" + item?.comment + ")"
                                      : ""
                                  }`}</p>
                                  <span>{formattedDateTime}</span>
                                </div>
                                <div className="pointsSpentAmountNo">
                                  <p
                                    className={`mb-0 ${
                                      type == "minus" ? "redTxt" : "greenTxt"
                                    }`}
                                  >
                                    {" "}
                                    {type == "minus" ? "-" : "+"} {points}
                                  </p>
                                </div>
                                <div
                                  className="pointsSpentAmountViewMoreBtn"
                                  onClick={() => {
                                    handleAccordionOpen(item.id);
                                  }}
                                >
                                  <ChevronDown />
                                </div>
                              </div>
                              {isSelectedItem == item.id && (
                                <div className="pointsSpentAmountViewMoreWrap bg-white">
                                  <table className="table table-bordered">
                                    <tr>
                                      {type == "minus" ? (
                                        <th colSpan={3}>
                                          Points were debited using
                                        </th>
                                      ) : (
                                        <th colSpan={3}>
                                          Points were credited using
                                        </th>
                                      )}
                                    </tr>
                                    <tr>
                                      <td>Order Id</td>
                                      {item.transaction_desc !==
                                        "Miscredit" && <td>Order item</td>}
                                      <td>Redeemed Points</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        {item.transaction_desc == "Miscredit"
                                          ? item.tds_order_id
                                          : item.order_id}
                                      </td>
                                      {item.transaction_desc !==
                                        "Miscredit" && (
                                        <td>{item.order_item_name}</td>
                                      )}
                                      <td
                                        className={
                                          type == "minus"
                                            ? "redTxt"
                                            : "greenTxt"
                                        }
                                      >
                                        {item.transaction_type == "D"
                                          ? "-"
                                          : "+"}
                                        {points}
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              )}
                            </Col>
                          );
                        })}
                        {isAllTab && (
                          <Row className="justify-content-center my-4">
                            <Col xs={12} lg={3}>
                              <PrimaryGradientButton
                                onClick={handleShowMore}
                                buttonText="Show More"
                                disabled={!hasMore}
                              />
                            </Col>
                          </Row>
                        )}
                      </Row>
                    )} */}
                    {isAllTab && (
  <Row>
   {trnasc_list?.map((item, index) => {
  const isDebit = item.transaction_type === "D";
  const title = item.transaction_desc;

  const points =
    currentTab === "tds_deduct"
      ? item.tds_points
      : item.reward_points;

  const formattedDateTime = formatDate(item.created_at, "y");

  return (
    <Col xs={12} key={index} className="mb-3">
      <Accordion>
        <Accordion.Item eventKey={index.toString()}>

          {/* HEADER */}
          <Accordion.Header>
            <div className="w-100 d-flex justify-content-between align-items-center">

              {/* LEFT */}
              <div className="text-start">
                <p className="mb-1 fw-semibold">
                  {title}{" "}
                  {!!item?.comment && `(${item.comment})`}
                </p>
                <small className="text-muted">
                  {formattedDateTime}
                </small>
              </div>

              {/* RIGHT */}
              <div>
                <p
                  className={`mb-0 fw-bold ${
                    isDebit ? "text-danger" : "text-success"
                  }`}
                >
                  {isDebit ? `- ${points}` : `+ ${points}`}
                </p>
              </div>

            </div>
          </Accordion.Header>

          {/* BODY */}
          <Accordion.Body>
            <div className="bg-white p-2 rounded shadow-sm">

              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th colSpan="3" className="text-center">
                      {isDebit
                        ? "Points were debited using"
                        : "Points were credited using"}
                    </th>
                  </tr>
                  <tr>
                    <th>Order Id</th>
                    {title !== "Miscredit" && <th>Order Item</th>}
                    <th>Points</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>
                      {title === "Miscredit"
                        ? item.tds_order_id
                        : item.order_id}
                    </td>

                    {title !== "Miscredit" && (
                      <td>{item.order_item_name || "-"}</td>
                    )}

                    <td
                      className={`fw-semibold ${
                        isDebit ? "text-danger" : "text-success"
                      }`}
                    >
                      {isDebit ? "-" : "+"} {points}
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </Accordion.Body>

        </Accordion.Item>
      </Accordion>
    </Col>
  );
})}
    {isAllTab && (
      <Row className="justify-content-center my-4">
        <Col xs={12} lg={3}>
          <PrimaryGradientButton
            onClick={handleShowMore}
            buttonText="Show More"
            disabled={!hasMore}
          />
        </Col>
      </Row>
    )}
  </Row>
)}

                    {/* //Debit */}
                    {isDebitTab && (
  <>
    <Row>
      {debit_list.map((item, index) => {
        const isDebit = item.transaction_type === "D";
        const title = item.transaction_desc;
        const points = isTdsDeductTab
          ? item.tds_points
          : item.reward_points;

        const formattedDateTime = formatDate(item.created_at, "y");

        return (
          <Col xs={12} key={index} className="mb-3">
            <Accordion>
              <Accordion.Item eventKey={index.toString()}>
                
                {/* HEADER */}
                <Accordion.Header>
                  <div className="w-100 d-flex justify-content-between align-items-center">

                    {/* LEFT */}
                    <div className="text-start">
                      <p className="mb-1 fw-semibold">
                        {title}{" "}
                        {!!item?.comment && `(${item.comment})`}
                      </p>
                      <small className="text-muted">
                        {formattedDateTime}
                      </small>
                    </div>

                    {/* RIGHT */}
                    <div>
                      <p
                        className={`mb-0 fw-bold ${
                          isDebit ? "text-danger" : "text-success"
                        }`}
                      >
                        {isDebit ? `- ${points}` : `+ ${points}`}
                      </p>
                    </div>

                  </div>
                </Accordion.Header>

                {/* BODY */}
                <Accordion.Body>
                  <div className="bg-white p-2 rounded shadow-sm">

                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th colSpan="3" className="text-center">
                            {isDebit
                              ? "Points were debited using"
                              : "Points were credited using"}
                          </th>
                        </tr>
                        <tr>
                          <th>Order Id</th>
                          {title !== "Miscredit" && <th>Order Item</th>}
                          <th>Points</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            {title === "Miscredit"
                              ? item.tds_order_id
                              : item.order_id}
                          </td>

                          {title !== "Miscredit" && (
                            <td>{item.order_item_name || "-"}</td>
                          )}

                          <td
                            className={`fw-semibold ${
                              isDebit ? "text-danger" : "text-success"
                            }`}
                          >
                            {isDebit ? "-" : "+"} {points}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </Accordion.Body>

              </Accordion.Item>
            </Accordion>
          </Col>
        );
      })}
    </Row>

    {/* SHOW MORE BUTTON */}
    <Row className="justify-content-center my-4">
      <Col xs={12} lg={3}>
        <PrimaryGradientButton
          onClick={handleShowMore}
          buttonText="Show More"
          disabled={!hasMore}
        />
      </Col>
    </Row>
  </>
)}

                    {/* //TDS */}
                    {/* {isTdsDeductTab && (
                      <Row>
                        {tds_list?.map((item, index) => {
                          const type =
                            item.transaction_type == "D" ? "minus" : "plus";
                          const title = item.transaction_desc;
                          const points = isTdsDeductTab
                            ? item.tds_points
                            : item.reward_points;
                          const dateTime = new Date(item.created_at);
                          const formattedDateTime = dateTime.toLocaleString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                              hour12: true,
                            }
                          );
                          return (
                            <Col xs={12} key={index}>
                              <div className="pointsSpentBlock ad-acc">
                                <div className="pointsSpentAmount col text-right">
                                  <p>
                                    {title}{" "}
                                    {!!item?.comment
                                      ? "(" + item?.comment + ")"
                                      : ""}
                                  </p>
                                  <span>{formattedDateTime}</span>
                                </div>
                                <div className="pointsSpentAmountNo">
                                  <p className="redTxt mb-0">
                                    {type == "minus" ? -1 * points : points}
                                  </p>
                                </div>
                                <div
                                  className="pointsSpentAmountViewMoreBtn"
                                  onClick={() => {
                                    handleAccordionOpen(item.id);
                                  }}
                                >
                                  <ChevronDown />
                                </div>
                              </div>
                              {isSelectedItem == item.id && (
                                <div className="pointsSpentAmountViewMoreWrap bg-white">
                                  <table className="table table-bordered">
                                    <tr>
                                      <th colSpan={3}>
                                        Points were debited using
                                      </th>
                                    </tr>
                                    <tr>
                                      <td>Order Id</td>
                                      <td>Redeemed Points</td>
                                    </tr>
                                    <tr>
                                      <td>{item.tds_order_id}</td>
                                      <td>-{points}</td>
                                    </tr>
                                  </table>
                                </div>
                              )}
                            </Col>
                          );
                        })}
                        {isTdsDeductTab && (
                          <Row className="justify-content-center my-4">
                            <Col xs={12} lg={3}>
                              <PrimaryGradientButton
                                onClick={handleShowMore}
                                buttonText="Show More"
                                disabled={!hasMore}
                              />
                            </Col>
                          </Row>
                        )}
                      </Row>
                    )} */}
                    {isTdsDeductTab && (
  <Row>
    {tds_list?.map((item, index) => {
  const isDebit = item.transaction_type === "D";
  const title = item.transaction_desc;
  const points = isTdsDeductTab ? item.tds_points : item.reward_points;
  const formattedDateTime = formatDate(item.created_at, "y");

  return (
    <Col xs={12} key={index} className="mb-3">
      <Accordion>
        <Accordion.Item eventKey={index.toString()}>
          <Accordion.Header>
            <div className="w-100 d-flex justify-content-between align-items-center">

              {/* LEFT SECTION */}
              <div className="text-start">
                <p className="mb-1 fw-semibold">
                  {title}{" "}
                  {!!item?.comment && `(${item.comment})`}
                </p>
                <small className="text-muted">
                  {formattedDateTime}
                </small>
              </div>

              {/* RIGHT SECTION */}
              <div>
                <p
                  className={`mb-0 fw-bold ${
                    isDebit ? "text-danger" : "text-success"
                  }`}
                >
                  {isDebit ? `- ${points}` : `+ ${points}`}
                </p>
              </div>

            </div>
          </Accordion.Header>

          <Accordion.Body>
            <div className="bg-white p-2 rounded">

              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th colSpan="2" className="text-center">
                      Points Transaction Details
                    </th>
                  </tr>
                  <tr>
                    <th>Order Id</th>
                    <th>Redeemed Points</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>{item.tds_order_id || "-"}</td>
                    <td className="text-danger">- {points}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Col>
  );
})}
    {isTdsDeductTab && (
      <Row className="justify-content-center my-4">
        <Col xs={12} lg={3}>
          <PrimaryGradientButton
            onClick={handleShowMore}
            buttonText="Show More"
            disabled={!hasMore}
          />
        </Col>
      </Row>
    )}
  </Row>
)}

                    {isBlockedTdsTab && (
                      <>
                        <Row>
                          <Col xs={12} lg={12}>
                            <div className="center-msg">
                              <h5>TDS bocked as per 194R government policy</h5></div>
                          </Col>
                        </Row>
                        <Row>
                        {blockedTds?.map((item, index) => {
  const formattedDateTime = formatDate(item.created_at, "y");

  return (
    <div
      key={index}
      className="mb-3 p-2 bg-white rounded shadow-sm d-flex justify-content-between align-items-center"
    >

      {/* LEFT */}
      <div className="text-start">
        <p className="mb-1 fw-sembold">
          {item.transaction_desc}
        </p>

        <small className="d-block text-muted">
          TDS for Order ID: {item.order_id || "-"}
        </small>

        <small className="text-muted">
          {formattedDateTime}
        </small>
      </div>

      {/* RIGHT */}
      <div>
        <p className="mb-0 fw-bold text-danger">
          - {item.tds_points}
        </p>
      </div>

    </div>
  );
})}
                        </Row>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
};

export default PointsSpent;
